module.exports = __webpack_public_path__ + "img/logo1.bac5c2f1.png";